import { PublicKey } from './types'

const getGlobalClient = () => (window as any).Payjp || undefined

const loadScript = () =>
  new Promise((resolve) => {
    if (typeof document === 'undefined') return

    const $script = document.createElement('script')
    $script.onload = () => {
      resolve(getGlobalClient())
    }
    $script.async = true
    $script.src = 'https://js.pay.jp/v2/pay.js'
    document.head.appendChild($script)
  })

let clientInstance: any = null

export const getClient = async (publicKey: PublicKey) => {
  if (clientInstance) return clientInstance

  let Payjp = getGlobalClient()

  if (!Payjp) {
    Payjp = await loadScript()
  }

  clientInstance = Payjp(publicKey)

  return clientInstance
}
